<div class="quick-help-compliance-status">
    <div class="row d-flex flex-wrap align-items-stretch">
        <div class="col-48 col-md-24 py-3 pr-md-0">
            <div class="px-3">
                <strong>{{title}}</strong><span [ngClass]="['GLOBAL_POLICY_OVERVIEW', 'POLICY_INFORMATION', 'COMMENT'] | monIcons" class="ml-1" aria-hidden="true" *ngIf="type === 'policy'"></span><br/>
                <p *ngIf="type === 'policy'">{{data.note}}</p>
                <quick-help-translations [seoName]="data.name" *ngIf="type === 'seo'"></quick-help-translations>
            </div>
        </div>
        <div class="col-48 col-md-24 compliance-status py-3 pl-md-0">
            <mon-spinner [loading]="loading">
                <div class="px-3">
                    <strong class="pb-3 inline-block"
                            translate
                            [translate-args]="{compliancePercentage: getCompliancePercentage() | monNumber:'0.[00]%'}">
                        Compliance [[compliancePercentage]]
                    </strong>
                    <accessibility-dashboard-distribution-progress-bar
                            [total]="totalPagesCount"
                            [fixed]="getPagesDone()">
                    </accessibility-dashboard-distribution-progress-bar>
                    <div class="d-flex justify-content-between mt-2">
                    <span translate
                          [translate-args]="{pagesDone: getPagesDone() | monNumber:'0', compliancePercentage: getCompliancePercentage() | monNumber:'0.[00]%'}">
                        [[pagesDone]] Pages ([[compliancePercentage]]) in compliance
                    </span>
                        <span translate
                              [translate-args]="{totalPageIssues: totalPageIssues, compliancePercentage: (1 - getCompliancePercentage()) | monNumber:'0.[00]%'}">
                        [[totalPageIssues]] Pages ([[compliancePercentage]]) to fix
                    </span>
                    </div>
                </div>
            </mon-spinner>
        </div>
    </div>
</div>
